import { useCallback } from 'react';
import { routes } from 'routes/routes';

export const usePathToVideoDetail = () => useCallback((id: string) => routes.video.detail(id), []);
